import './Quantity.scss';

import { useEffect } from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { fetchQuantity } from "../../slices/quantitySlice";

import { Box } from "@mui/material";
import { TableCell } from "@mui/material";
import { TableRow } from "@mui/material";
import { Table } from "@mui/material";
import { TableBody } from "@mui/material";
import { TableContainer } from "@mui/material";
import { TableHead } from "@mui/material";

const Quantity = () => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token?.data?.token || state.auth.token);
    const data = useSelector((state) => state.quantity.data);
 
    useEffect(() => {
        if (token) {
            dispatch(fetchQuantity({ token }));
        }
    }, [dispatch, token]);

    const emergencyTypes = [
        { id: "1", name: "Пожар" },
        { id: "2", name: "Травма" },
        { id: "3", name: "Отключение электроэнергии" },
        { id: "4", name: "Обрушение" },
        { id: "5", name: "Несчастный случай" },
        { id: "6", name: "Застревание" },
        { id: "7", name: "Заболевание" },
        { id: "8", name: "Затопление" },
        { id: "9", name: "ДТП" },
        { id: "10", name: "Загазованность" },
        { id: "11", name: "Взрыв" },
        { id: "12", name: "Обеспечение противопожарной" },
        { id: "13", name: "Поиск людей" },
        { id: "14", name: "Открытый фонтан" },
        { id: "15", name: "Розлив" },
        { id: "16", name: "Иное" }
    ]

    const branchOffices = [
        {
            branch_office_id: "1",
            name: 'Актюбинский'
        },
        {
            branch_office_id: "2",
            name: 'Атырауский'
        },
        {
            branch_office_id: "3",
            name: "ВКФ"
        },
        {
            branch_office_id: "4",
            name: "ЗКФ"
        },
        {
            branch_office_id: "5",
            name: "Карагандинский"
        },
        {
            branch_office_id: "6",
            name: "Кызылординский"
        },
        {
            branch_office_id: "7",
            name: "Мангистауский"
        },
        {
            branch_office_id: "8",
            name: "Павлодарский"
        },
        {
            branch_office_id: "9",
            name: "СКФ"
        },
        {
            branch_office_id: "10",
            name: "ЮКФ"
        },
        {
            branch_office_id: "11",
            name: "Акмолинский"
        },
        {
            branch_office_id: "12",
            name: "Сериктес"
        },
        {
            branch_office_id: "13",
            name: "АСРС"
        }
    ]

    if (!data || !data.cells) {
        return null;
    }

    const groupedByEmergency = data.cells.reduce((acc, cell) => {
        if (!acc[cell.emergency_type]) {
            acc[cell.emergency_type] = {};
        }
        acc[cell.emergency_type][cell.branch_office_id] = cell.count;
        return acc;
    }, {});


    const rows = emergencyTypes.map(type => {
        const branchData = branchOffices.map(office => {
            return groupedByEmergency[type.id]?.[office.branch_office_id] || 0;
        });

        const totalForType = data.total_per_type[type.id] || 0;

        return {
            emergencyType: type.name,
            branches: branchData,
            totalForType
        };
    });

    const totalRegisteredPerBranch = branchOffices.map(office => {
        return data.total_per_branch_office[office.branch_office_id] || 0;
    });

    const overallTotal = data.overall_total;

    return (
        <Box className={"quantity"}>
            <TableContainer className={"quantity_container"}>
                <Table className={"quantity_container_table"}>
                    <TableHead sx={{backgroundColor: "#FBFCFE"}}>
                        <TableRow className={"quantity_container_table_header"}>
                            <TableCell sx={{color: "#000"}}>Наименование аварийной ситуации</TableCell>
                            {branchOffices.map(office => (
                                <TableCell sx={{color: "#000"}} align={"center"} className={"vertical_text"} key={office.id}>{office.name}</TableCell>
                            ))}
                            <TableCell sx={{color: "#000"}}>Всего</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody className="quantity_container_table_body">
                        {rows.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell>{row.emergencyType}</TableCell>
                                {row.branches.map((count, i) => (
                                    <TableCell align={"center"} key={i}>{count}</TableCell>
                                ))}
                                <TableCell>{row.totalForType}</TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell>Всего зарегистрировано</TableCell>
                            {totalRegisteredPerBranch.map((total, i) => (
                                <TableCell align={"center"} key={i}>{total}</TableCell>
                            ))}
                            <TableCell>{overallTotal}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default Quantity;